module.exports = __webpack_public_path__ + "img/五星特级大师@2x.6a9aa866.png";